import React from "react";
import CreatePaymentMethods from "./components/create-payment-methods/CreatePaymentMethods";

export const PaymentMethods = ({
	onAddPaymentMethod,
	addPaymentMethodMode,
	setAddPaymentMethodMode,
	fixedFooter,
}) => {
	return (
		<CreatePaymentMethods
			onAddPaymentMethod={onAddPaymentMethod}
			addPaymentMethodMode={addPaymentMethodMode}
			setAddPaymentMethodMode={setAddPaymentMethodMode}
			fixedFooter={fixedFooter}
		/>
	);
};